module.exports = __webpack_public_path__ + "static/landry-gapangwa-737553-unsplash-b91400b0f39faca6c7956d2191be0fe8.jpg";